import React, { useEffect, useState } from 'react';
import { useHttp } from '../../../../hooks/http.hook';
import { useMessageError, useMessageSuccess } from '../../../../hooks/message.hook';
import DiscountForm from '../../../../components/Forms/DiscountForm/DiscountForm'; // Assuming DiscountForm is a separate component

const FormWrapper = ({ edit, create, id, close}) => {
    const { request } = useHttp();
    const messageError = useMessageError();
    const messageSuccess = useMessageSuccess();
    const [initialValues, setInitialValues] = useState({
        name: "",
        quantity: "",
        active: false,
        dateEnd: new Date().toISOString().split('T')[0]
    });

    const getById = async () => {
        try {
            const data = await request(`admin/discounts/get/${id}`, "GET");
            setInitialValues(data.data);
            messageSuccess(data.message);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (edit) getById();
    }, [edit]);

    const onSubmit = async (values) => {
        try {
            if (create) {
                const data = await request(`admin/discounts/create`, "POST", { ...values });
                messageSuccess(data.message);
                close(true);
            }

            if (edit) {
                const data = await request(`admin/discounts/edit/${id}`, "PUT", { ...values });
                messageSuccess(data.message);
                close(true);
            }
        } catch (e) {
            messageError(e);
        }
    };

    return (
        <div>
            <DiscountForm initialValues={initialValues} onSubmit={onSubmit} edit={edit} create={create}/>
        </div>
    );
};

export default FormWrapper;
